<img [src]="'/assets/images/' + item.icon" alt="">
<span>{{ item.title }}</span>
